const siniestro = {}

siniestro.coberturas = {
  soat: [
    { key: 'incapacidad-temporal', name: 'Incapacidad Temporal', img: 'cobertura-incapacidad-temporal.png', tooltip: 'Si cuentas con un descanso médico luego de un accidente.' },
    { key: 'gastos-medicos', name: 'Gastos médicos', img: 'cobertura-gastos-medicos.png', tooltip: 'En caso de gastos extras a la cobertura médica.' },
    { key: 'invalidez', name: 'Invalidez', img: 'cobertura-invalidez.png', tooltip: 'Si luego de un accidente tienes incapacidad física permanente.' },
    { key: 'fallecimiento', name: 'Fallecimiento', img: 'cobertura-fallecimiento.png', tooltip: 'En caso el lesionado fallece.' },
    { key: 'gastos-sepelio', name: 'Gastos de Sepelio', img: 'cobertura-gastos-sepelio.png', tooltip: 'Gastos funerarios.' }
  ],
  vida: [
    { key: 'fallecimiento', name: 'Fallecimiento', img: 'cobertura-fallecimiento.png', tooltip: 'En caso el asegurado fallece.' },
    { key: 'invalidez', name: 'Invalidez', img: 'cobertura-invalidez.png', tooltip: 'Si luego de un accidente tienes incapacidad física permanente.' },
    { key: 'otros', name: 'Otras coberturas', img: 'icono-otros.png' }
  ],
  'protección tarjeta': [
    {key: 'uso-indebido-tarjeta', name: 'Uso Indebido de Tarjeta', img: 'icono-proteccion-tarjeta.png'},
    {key: 'falsificacion-tarjeta', name: 'Falsificación de Tarjeta', img: 'icono-proteccion-tarjeta.png'},
    {key: 'compras-fraudulentas', name: 'Compras Fraudulentas', img: 'icono-proteccion-tarjeta.png'},
    {key: 'utilizacion-forzada-tarjeta-digital', name: 'Utilización Forzada de Tarjeta Digital', img: 'icono-proteccion-tarjeta.png'},
    {key: 'robo-efectivo', name: 'Robo de Efectivo', img: 'icono-proteccion-tarjeta.png'},
    {key: 'uso-malicioso-documento-identidad', name: 'Uso Malicioso de Documento de Identidad', img: 'icono-proteccion-tarjeta.png'},
    {key: 'gastos-tramite-documentos', name: 'Gastos por Trámite de Documentos', img: 'icono-proteccion-tarjeta.png'},
    {key: 'compra-protegida', name: 'Compra Protegida', img: 'icono-proteccion-tarjeta.png'}
  ]
}

siniestro.documentos = {
  vida: {
    'Invalidez': ['Certificado de invalidez', 'Historia clínica'],
    'Fallecimiento': ['Certificado de defunción', 'Historia clínica', 'DNI de los beneficiarios'],
    'Otras coberturas': []
  },
  soat: {
    'Incapacidad Temporal': ['Denuncia Policial', 'Certificado médico'],
    'Gastos médicos': ['Denuncia Policial', 'Comprobantes de pago'],
    'Invalidez': ['Denuncia Policial', 'Certificado médico'],
    'Fallecimiento': ['Denuncia Policial', 'Certificado de defunción', 'Declaración Jurada de beneficiarios'],
    'Gastos de Sepelio': ['Denuncia Policial', 'Comprobantes de pago']
  },
  'protección tarjeta': {
    'Uso Indebido de Tarjeta': [],
    'Falsificación de Tarjeta': [],
    'Compras Fraudulentas': [],
    'Utilización Forzada de Tarjeta Digital': [],
    'Robo de Efectivo': [],
    'Uso Malicioso de Documento de Identidad': [],
    'Gastos por Trámite de Documentos': [],
    'Compra Protegida': []
  }
}

export default siniestro



// WEBPACK FOOTER //
// ./src/interfaces/siniestros.js